// src/api/apiClient.ts
import { TaskUser } from "../types/taskuser";
//import { Issue } from "../types/issue";
import { DprReportRow } from "../types/dpr";
//import { DailyProgressDprRow } from "../types/dailyProgressDpr";
import { DailyProgressDprResponse } from "../types/dailyProgressDpr";
import { GanttWorkItem } from "../types/gantt";




const API_BASE =
  process.env.REACT_APP_API_BASE || "https://localhost:7243/api";

/**
 * Generic fetch wrapper with automatic Authorization header
 */
async function apiFetch<T>(
  endpoint: string,
  options: RequestInit = {}
): Promise<T> {

  const fallbackToken =
    localStorage.getItem("authToken") ||
    localStorage.getItem("token") ||
    null;

  const headers = {
    "Content-Type": "application/json",

    ...(fallbackToken &&
      !(
        (options.headers as HeadersInit | undefined)?.hasOwnProperty?.("Authorization") ||
        (options.headers as Record<string, string> | undefined)?.Authorization
      )
        ? { Authorization: `Bearer ${fallbackToken}` }
        : {}),

    ...options.headers,
  };

  const response = await fetch(
    `${API_BASE}${endpoint}`,
    {
      ...options,
      headers,

      // NEW FROM FILE 2
      credentials: "include",
    }
  );

  if (response.status === 401) {

    console.error(
      "[apiFetch] 401 Unauthorized",
      {
        endpoint,
        method: options.method ?? "GET",
      }
    );

    localStorage.removeItem("user");

    window.location.href = "/login";

    throw new Error("Unauthorized");
  }

  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || response.statusText);
  }

  if (response.status === 204) {
    return {} as T;
  }

  return (await response.json()) as T;
}


type AuthResponse = {
  message: string;
  user?: any;
  token?: string;
};

/* =============================
   AUTH
============================= */
export const AuthAPI = {
 login: (
  email: string,
  password: string
) =>
  apiFetch<AuthResponse>(
    "/auth/login",
    {
      method: "POST",
      body: JSON.stringify({
        email,
        password
      }),
    }
  ),
    register: (userName: string, password: string, email?: string) =>
    apiFetch<{ token: string; user?: any }>("/auth/register", {
      method: "POST",
      body: JSON.stringify({ userName, password, email }),
    }),


    // ✅ ADD THIS
  forgotPassword: (email: string) =>
    apiFetch<void>("/auth/forgot-password", {
      method: "POST",
      body: JSON.stringify({ email }),
    }),

  // ✅ ADD THIS
  resetPassword: (token: string, newPassword: string) =>
    apiFetch<void>("/auth/reset-password", {
      method: "POST",
      body: JSON.stringify({ token, newPassword }),
    }),
verifyEmailOtp: (email: string, otp: string) =>
  apiFetch<{ message: string }>("/auth/verify-email", {
    method: "POST",
    body: JSON.stringify({
      email,
      otp,
    }),
  }),

resendEmailOtp: (email: string) =>
  apiFetch<{ message: string }>("/auth/resend-email-otp", {
    method: "POST",
    body: JSON.stringify({
      email,
    }),
  }),
    
};

/* =============================
   COMPANY
============================= */
export const CompanyAPI = {
  registerCompany: (payload: {
    clientName: string
    description?: string
    contactPerson?: string
    email?: string
    phoneNo?: string
    companyWebsite?: string
  }) =>
    apiFetch("/RegisterCompany", {
      method: "POST",
      body: JSON.stringify(payload)
    }),
};
export const CompanyAdminAPI = {
  login: (email: string, password: string) =>
    apiFetch("/CompanyAdmin/login", {
      method: "POST",
      body: JSON.stringify({ email, password }),
    }),
};
/*export const CompanyUsersAPI = {
  //addUser: (data: { adminEmail: string; email: string }) =>
    //apiFetch("/CompanyAdmin/add-user", {
  addUser: (data: { adminEmail: string; email: string }) =>
  apiFetch<{ message: string }>("/CompanyAdmin/add-user", {
      method: "POST",
      body: JSON.stringify(data),
    }),

     // ✅ ADD THIS
  removeUser: (data: { adminEmail: string; email: string }) =>
    apiFetch("/CompanyAdmin/remove-user", {
      method: "POST",
      body: JSON.stringify(data),
    }),
  
  getCompanyUsers: (adminEmail: string) =>
    apiFetch(`/CompanyAdmin/company-users/${adminEmail}`),

  getAvailableUsers: () =>
    apiFetch("/CompanyAdmin/available-users"),*/

  /*getAllProjects: () =>
    apiFetch("/CompanyAdmin/all-projects"),

  assignProject: (data: { adminEmail: string; projectId: number }) =>
    apiFetch("/CompanyAdmin/assign-project", {
      method: "POST",
      body: JSON.stringify(data),
    }),*/
    // ✅ NEW (ONLY PROJECT API)
  
  /*  getCompanyProjects: (adminEmail: string) =>
    apiFetch(`/CompanyAdmin/company-projects/${adminEmail}`),
};*/

export const CompanyUsersAPI = {

  // ✅ ADD USER
  addUser: (data: { email: string;role: string }) =>
    apiFetch<{ message: string }>("/CompanyAdmin/add-user", {
      method: "POST",
      body: JSON.stringify(data),
    }),

  // ✅ REMOVE USER
  removeUser: (data: { email: string }) =>
    apiFetch<{ message: string }>("/CompanyAdmin/remove-user", {
      method: "POST",
      body: JSON.stringify(data),
    }),

  // ✅ GET COMPANY USERS (NO PARAMS)
 /* getCompanyUsers: () =>
    apiFetch<string[]>("/CompanyAdmin/company-users"),*/
 getCompanyUsers: () =>
  apiFetch<any[]>("/CompanyAdmin/company-users"),

  // ✅ GET AVAILABLE USERS
  getAvailableUsers: () =>
    apiFetch<string[]>("/CompanyAdmin/available-users"),

  // ✅ GET COMPANY PROJECTS (NO PARAMS)
  getCompanyProjects: () =>
    apiFetch<any[]>("/CompanyAdmin/company-projects"),

  // ✅ ADD THESE 👇
 // getAvailableProjects: () =>
   // apiFetch<any[]>("/CompanyAdmin/available-projects"),

 /* assignProject: (projectNo: number) =>
    apiFetch<{ message: string }>("/CompanyAdmin/assign-project", {
      method: "POST",
      body: JSON.stringify(projectNo),
    }),*/
 // ✅ ⭐ ADD THIS (VERY IMPORTANT)
  assignUserToProject: (data: { projectNo: number; email: string }) =>
    apiFetch<{ message: string }>("/CompanyAdmin/assign-user-to-project", {
      method: "POST",
      body: JSON.stringify(data),
    }),

    // ✅ REMOVE USER FROM PROJECT (ADD THIS)
removeUserFromProject: (data: { projectNo: number; email: string }) =>
  apiFetch<{ message: string }>("/CompanyAdmin/remove-user-from-project", {
    method: "POST",
    body: JSON.stringify(data),
  }),

  getUserRole: (email: string) =>
  apiFetch<{ role: string }>(
    `/CompanyAdmin/user-role?email=${encodeURIComponent(email)}`
  ),

updateUserRole: (data: { email: string; role: string }) =>
  apiFetch<{ message: string }>("/CompanyAdmin/update-user-role", {
    method: "PUT",
    body: JSON.stringify(data),
  }),
    
};


/*export const SuperAdminAPI = {
  getCompanies: () =>
    apiFetch("/SuperAdmin/companies"),

  getProjects: () =>
    apiFetch("/SuperAdmin/projects"),

  assignProject: (data: { projectId: number; companyId: number }) =>
    apiFetch("/SuperAdmin/assign-project", {
      method: "POST",
      body: JSON.stringify(data),
    }),
};*/

/* =============================
   PROJECTS
============================= */
export const ProjectAPI = {
  getAll: () => apiFetch<any[]>("/projects"),
  getIssues: (projectId: number) => 
    apiFetch<any[]>(`/projects/${projectId}/issues`),
  getUsers: (projectId: number) =>
    apiFetch<any[]>(`/projects/${projectId}/users`),
 
  getAllIssues: (projectId: number, params: URLSearchParams) =>
    apiFetch(`/projects/${projectId}/issues/all?${params.toString()}`),
  /*getAllIssues: (projectId: number, params?: URLSearchParams | null) => {
  let url = `/projects/${projectId}/issues/all`;

  // ✅ ONLY add query when params exist
  if (params && params.toString()) {
    url += `?${params.toString()}`;
  }

  return apiFetch(url);
},*/
  
  
  getTaskGroups: (projectId: number) =>
    apiFetch<{ taskGroupNo: number; taskGroupName: string }[]>(
      `/projects/${projectId}/taskgroups`
    ),
  markIssueRead: (projectId: number, taskId: number) =>
  apiFetch(`/projects/${projectId}/issues/${taskId}/read`, {
    method: "POST"
  }),
   // ✅ ADD THIS (GANTT)
  // =============================
  getGantt: (projectId: number, asOnDate: string) =>
    apiFetch<any[]>(
      `/gantt/project/${projectId}?asOnDate=${asOnDate}`
    ),
exportPdf: async (
  projectName: string,
  asOnDate: string,
  showPlanned: boolean,
  showActual: boolean,
  showForecast: boolean,
  expandedIds: number[],
  items: GanttWorkItem[]
) => {
  const token = localStorage.getItem("token");

  const response = await fetch(`${API_BASE}/GanttPdf/export-pdf`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({
      frontendUrl: `${window.location.origin}/gantt-print`,
      projectName,
      asOnDate,
      showPlanned,
      showActual,
      showForecast,
      expandedIds,
      items,
    }),
  });

  if (!response.ok) {
    throw new Error("Failed to export PDF");
  }

  return response.blob();
},

  
    /*getGantt: (projectId: number, asOnDate: string) =>
  apiFetch<any[]>(
    `/gantt/project/${projectId}?asOnDate=${asOnDate}&wbs=${-1 * projectId}`
  ),*/



};

/* =============================
   CHAT
============================= */
export const ChatAPI = {
  // Project chat
  getProjectChat: (projectId: number) =>
    apiFetch<any[]>(`/projects/${projectId}/chat`),

  postProjectMessage: (projectId: number, message: string) =>
    apiFetch(`/projects/${projectId}/chat`, {
      method: "POST",
      body: JSON.stringify({ message }),
    }),

      editProjectMessage: (
    projectId: number,
    messageNo: number,
    message: string
  ) =>
    apiFetch(`/projects/${projectId}/chat/${messageNo}`, {
      method: "PUT",
      body: JSON.stringify({ message }),
    }),

  deleteProjectMessage: (
    projectId: number,
    messageNo: number
  ) =>
    apiFetch(`/projects/${projectId}/chat/${messageNo}`, {
      method: "DELETE",
    }),

  // Issue-level chat
  getIssueChat: (taskId: number) =>
    apiFetch<any[]>(`/messages/${taskId}`),

  postIssueMessage: (taskId: number, message: string) =>
    apiFetch(`/messages`, {
      method: "POST",
      body: JSON.stringify({ task: taskId, message }),
    }),

    // ✏️ EDIT ISSUE MESSAGE
editMessage: (messageNo: number, message: string) =>
  apiFetch(`/messages/${messageNo}`, {
    method: "PUT",
    body: JSON.stringify({ message }),
  }),

// 🗑 DELETE ISSUE MESSAGE
deleteMessage: (messageNo: number) =>
  apiFetch(`/messages/${messageNo}`, {
    method: "DELETE",
  }),


};


/* =============================
   FILES
============================= */
/*export const FileAPI = {
  upload: (file: File, taskNo: number, userNo: number) => {
    const token = localStorage.getItem("token");

    const formData = new FormData();
    formData.append("File", file);
    formData.append("TaskNo", taskNo.toString());
    formData.append("UserNo", userNo.toString());

    return fetch(`${API_BASE}/files/upload`, {
      method: "POST",
      body: formData,
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    }).then(async (res) => {
      if (!res.ok) {
        const msg = await res.text();
        throw new Error(msg);
      }
      return res.json();
    });
  },
};*/

export const FileAPI = {
  upload: (
    file: File,
    userNo: number,
    taskNo?: number,
    projectNo?: number
  ) => {
   
    const formData = new FormData();
    formData.append("File", file);
    formData.append("UserNo", userNo.toString());

    if (taskNo) {
      formData.append("TaskNo", taskNo.toString());
    }

    if (projectNo) {
      formData.append("ProjectNo", projectNo.toString());
    }

    return fetch(`${API_BASE}/files/upload`, {
      method: "POST",
      body: formData,
      credentials: "include",
    }).then(async (res) => {
      if (!res.ok) {
        const msg = await res.text();
        throw new Error(msg);
      }
      return res.json();
    });
  },
};





export const IssueAPI = {
  //<Issue> added newly in apifetch 
  getDetails:(projectId: number, taskId: number) =>
    apiFetch(`/projects/${projectId}/issues/${taskId}`),

  //<Issue> added newly in apifetch 
  create:(projectId: number, dto: any) =>
    apiFetch(`/projects/${projectId}/issues`, {
      method: "POST",
      body: JSON.stringify(dto),
    }),

  update: (projectId: number, taskId: number, payload: any) =>
    apiFetch(`/projects/${projectId}/issues/${taskId}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    }),
};
export const TaskUsersAPI = {
  list: (taskId: number) =>
    apiFetch<TaskUser[]>(`/tasks/${taskId}/users`),

  assign: (taskId: number, userNo: number, role?: string) =>
    apiFetch(`/tasks/${taskId}/users`, {
      method: "POST",
      body: JSON.stringify({ userNo, role })
    }),

  unassign: (taskId: number, userNo: number) =>
    apiFetch(`/tasks/${taskId}/users/${userNo}`, {
      method: "DELETE"
    })
};



export const ReportAPI = {
 /*  getPeriodReport: (projectId: number, fromDate: string, toDate: string) =>
    apiFetch(`/projects/${projectId}/reports/period?fromDate=${fromDate}&toDate=${toDate}`),
 
 */
  /* getSnapshotReport: (projectId: number, date: string) =>
    apiFetch(`/projects/${projectId}/reports/snapshot?toDate=${date}`),
 */
getPeriodReport: (
  projectId: number,
  fromDate: string,
  toDate: string,
  taskGroup?: string
) => {
  const params = new URLSearchParams();

  params.append("fromDate", fromDate);
  params.append("toDate", toDate);

  if (taskGroup) {
    params.append("taskGroup", taskGroup);
  }

  return apiFetch(
    `/projects/${projectId}/reports/period?${params.toString()}`
  );
},

  getSnapshotReport: (
  projectId: number,
  date: string,
  taskGroup?: string
) => {
  const params = new URLSearchParams();

  params.append("toDate", date);

  if (taskGroup) {
    params.append("taskGroup", taskGroup);
  }

  return apiFetch(
    `/projects/${projectId}/reports/snapshot?${params.toString()}`
  );
},
  
/*getDrsNotes: (drsId: number) =>
  apiFetch<any[]>(
    `/DRSNotesReportModule/${drsId}`
  ),*/

  getDrsNotes: (projectId: number, date: string) =>
  apiFetch<any[]>(
    `/DRSNotesReportModule?project=${projectId}&date=${date}`
  ),

  getLatestDrsDate: (projectId: number) =>
  apiFetch<string>(
    `/DRSNotesReportModule/latest-date?project=${projectId}`
  ),



 

/*getMaterialStatement: (
  payload: {
    project: number;
    qDate: string;
    endDate: string;
    vendor?: number;
    component?: number;
  }
) =>
  apiFetch<any[]>(
    "/material-statement",
    {
      method: "POST",
      body: JSON.stringify({
        vendor: -1,
        component: 0,
        ...payload
      })
    }
  ),*/

  getMaterialStatement: (
  payload: {
    project: number;
    qDate: string;
    endDate: string;
    vendor?: number;
    component?: number;
  }
) =>
  apiFetch<any[]>(
    "/material-statement",
    {
      method: "POST",
      body: JSON.stringify({
        project: payload.project,
        qDate: payload.qDate,
        endDate: payload.endDate,
        vendor: payload.vendor ?? -1,     // ✅ guaranteed
        component: payload.component ?? 0
      })
    }
  ),



   /*getMaterialReceipt: (payload: {
    project: number;
    fromDate: string;
    toDate: string;
    vendor?: number;
    cmp?: number;
  }) =>
    apiFetch<any[]>(
      `/MaterialReceiptReport/report?fromDate=${payload.fromDate}&toDate=${payload.toDate}&project=${payload.project}&vendor=${payload.vendor ?? -1}&cmp=${payload.cmp ?? 0}`
    ),*/


    getMaterialReceipt: (payload: {
  project: number;
  vendor?: number;
  cmp?: number;
}) =>
  apiFetch<any[]>(
    `/MaterialReceiptReport/report?project=${payload.project}&vendor=${payload.vendor ?? -1}&cmp=${payload.cmp ?? 0}`
  ),


 // ✅ DPR REPORT (ADD THIS)
  /*getDprReport: (wbs: number, qDate: string, lvl: number = 2) =>
    apiFetch<any[]>(
      `/DRSWorksTrxDPR/get-report?wbs=${wbs}&qDate=${qDate}&lvl=${lvl}`
    ),*/


   /* getDprReport: (wbs: number, qDate: string, lvl: number = 2) =>
  apiFetch<any[]>(
    `/DRSWorksTrxDPR/get-report?wbs=${wbs}&qDate=${qDate}&lvl=${lvl}`
  ),*/

  getDprReport: (wbs: number, lvl: number = 2) =>
  apiFetch<any[]>(
    `/DRSWorksTrxDPR/get-report?wbs=${wbs}&lvl=${lvl}`
  ),



    /*getMaterialReceipt: (payload: {
  project: number;
  asOnDate: string;
}) =>
  apiFetch<any[]>(
    `/materialreceipt?project=${payload.project}&asOnDate=${payload.asOnDate}`
  ),*/

/*getMaterialConsumption: (payload: {
  project: number;
  asOnDate: string;
}) =>
  apiFetch<any[]>(
    `/material-consumption?project=${payload.project}&asOnDate=${payload.asOnDate}`
  ),*/

  getMaterialConsumption: (payload: {
  project: number;
  vendor?: number;
  cmp?: number;
}) =>
  apiFetch<any[]>(
    `/material-consumption?project=${payload.project}&vendor=${payload.vendor ?? 0}&cmp=${payload.cmp ?? 0}`
  ),



  getDprCumulative: (wbs: number, qDate: string, lvl: number = 2) =>
  apiFetch<any[]>(
    `/DprCumulativeReport?wbs=${wbs}&qDate=${qDate}&lvl=${lvl}`
  ),

  /*getManPowerStatement: (payload: {
  qDate: string;
  endDate: string;
  project: number;
  vendor?: number;
  cmp?: number;
}) =>
  apiFetch<any[]>(
    "/ManPowerStatement",
    {
      method: "POST",
      body: JSON.stringify(payload),
    }
  ),*/

  getManPowerStatement: (payload: {
  project: number;
  vendor?: number;
  cmp?: number;
}) =>
  apiFetch<any[]>(
    "/ManPowerStatement",
    {
      method: "POST",
      body: JSON.stringify(payload),
    }
  ),


  /*getDailyTotalWorkforce: (payload: {
  qDate: string;
  endDate: string;
  project: number;
  vendor: number;
  cmp: number;
}) =>
  apiFetch(
    "/DailyTotalWorkforce",
    {
      method: "POST",
      body: JSON.stringify(payload),
    }
  ),*/


  getDailyTotalWorkforce: (payload: {
  project: number;
  vendor?: number;
  cmp?: number;
}) =>
  apiFetch(
    "/DailyTotalWorkforce",
    {
      method: "POST",
      body: JSON.stringify({
        project: payload.project,
        vendor: payload.vendor ?? -1,
        cmp: payload.cmp ?? 0,
      }),
    }
  ),
  /*getLookAheadReport: (wbs: number, qDate: string, level: number) =>
  apiFetch<any[]>(
    "/LookAheadReport/GetReport",
    {
      method: "POST",
      body: JSON.stringify({
        wbs,
        qDate,
        level
      })
    }
  ),*/
/* =============================
   PROGRESS / HELD UP WORKS
============================= */
/*getProgress: (projectId: number) =>
  apiFetch<any[]>(
    `/progress?projectId=${projectId}`
  ),*/
  
/* =============================
   DAILY DPR REPORT
============================= */
/*getDailyProgressDpr: (wbs: number, qDate: string, lvl: number = 2) =>
  apiFetch<DailyProgressDprRow[]>(
    `/dpr-module/report?wbs=${wbs}&qDate=${qDate}&lvl=${lvl}`
  ),*/
 //2nd code
 /* getDailyProgressDpr: (wbs: number, qDate: string, lvl: number = 2) =>
  apiFetch<DailyProgressDprResponse>(
    `/dpr-module/report?wbs=${wbs}&qDate=${qDate}&lvl=${lvl}`
  ),*/

  getDailyProgressDpr: (wbs: number, lvl: number = 2) =>
  apiFetch<DailyProgressDprResponse>(
    `/dpr-module/report?wbs=${wbs}&lvl=${lvl}`
  ),

/* =============================
   SITE SNAPSHOT PROGRESS (WGTrxReport)
============================= */
/*getSiteSnapshotProgress: (projectId: number, date: string) =>
  apiFetch<any[]>(
    "/WGSnapshotProgress",
    {
      method: "POST",
      body: JSON.stringify({
        projectNo: projectId,
        dataDate: date
      })
    }
  ),*/
/* =============================
   LOOK AHEAD PROGRESS REPORT
============================= */

/*getLookAheadProgressReport: (
  wbs: number,
  qDate: string,
  level: number = 0
) =>
  apiFetch<any[]>(
    `/LookAheadReportFeature?wbs=${wbs}&qDate=${qDate}&level=${level}`
  ),*/
  getLookAheadProgressReport: (
  wbs: number,
  level: number = 0
) =>
  apiFetch<any[]>(
    `/LookAheadReportFeature?wbs=${wbs}&level=${level}`
  ),

  /* =============================
   EQUIPMENT LATEST PLANT-IN
============================= */
/*getEquipmentLatestPlantIn: (payload: {
  project: number;
  qDate: string;
  endDate: string;
  vendor?: number;
  cmp?: number;
}) =>
  apiFetch<any[]>(
    `/StatementEquipmentLatestPlantIn/latest?qDate=${payload.qDate}&endDate=${payload.endDate}&project=${payload.project}&vendor=${payload.vendor ?? -1}&cmp=${payload.cmp ?? 0}`
  ),*/
  getEquipmentLatestPlantInDashboard: (payload: {
  project: number;
  vendor?: number;
  cmp?: number;
}) =>
  apiFetch<any[]>(
    `/StatementEquipmentLatestPlantIn/dashboard?project=${payload.project}&vendor=${payload.vendor ?? -1}&cmp=${payload.cmp ?? 0}`
  ),

/* =============================
   EQUIPMENT LATEST PLANT-OUT
============================= */

/*getEquipmentLatestPlantOut: (payload: {
  project: number;
  qDate: string;
  endDate: string;
  vendor?: number;
  cmp?: number;
}) =>
  apiFetch<any[]>(
    "/EquipmentStatementLatestPlantOut/GetLatestPlantOut",
    {
      method: "POST",
      body: JSON.stringify({
        project: payload.project,
        qDate: payload.qDate,
        endDate: payload.endDate,
        vendor: payload.vendor ?? -1,
        cmp: payload.cmp ?? 0,
      }),
    }
  ),*/

  /* =============================
   EQUIPMENT LATEST PLANT-OUT DASHBOARD
============================= */

getEquipmentLatestPlantOutDashboard: (payload: {
  project: number;
  vendor?: number;
  cmp?: number;
}) =>
  apiFetch<any[]>(
    `/EquipmentStatementLatestPlantOut/dashboard?project=${payload.project}&vendor=${payload.vendor ?? -1}&cmp=${payload.cmp ?? 0}`
  ),


/*getOverallScheduleStatus: (
  wbs: number,
  qDate: string,
  endDate: string,
  lvl: number = 0
) =>
  apiFetch<any[]>(
    `/OverallScheduleStatus?wbs=${wbs}&qDate=${qDate}&endDate=${endDate}&lvl=${lvl}`
  ),*/


  /*getOverallScheduleStatus: (
  wbs: number,
  qDate: string,
  endDate: string,
  lvl: number = 0,
  fv1: number = 1,
  overRide: number = 0
) =>
  apiFetch<any[]>(
    `/OverallScheduleStatus?wbs=${wbs}&qDate=${qDate}&endDate=${endDate}&lvl=${lvl}&fv1=${fv1}&overRide=${overRide}`
  ),*/

  getOverallScheduleStatusDashboard: (
  wbs: number,
  lvl: number = 0,
  fv1: number = 1,
  overRide: number = 0
) =>
  apiFetch<any[]>(
    `/OverallScheduleStatus/Dashboard?wbs=${wbs}&lvl=${lvl}&fv1=${fv1}&overRide=${overRide}`
  ),

  /* =============================
   MATERIAL DISPOSED SUMMARY
============================= */
/*getMaterialDisposedSummary: (payload: {
  project: number;
  qDate: string;
  endDate: string;
  vendor?: number;
  cmp?: number;
}) =>
  apiFetch<
    {
      materialName: string;
      unit: string;
      totalDisposed: number;
    }[]
  >(
    "/MaterialdisposedModule/summary",
    {
      method: "POST",
      body: JSON.stringify({
        project: payload.project,
        qDate: payload.qDate,
        endDate: payload.endDate,
        vendor: payload.vendor ?? 0,
        cmp: payload.cmp ?? 0
      }),
    }
  ),*/
  /* =============================
   MATERIAL DISPOSED SUMMARY (Dashboard - Latest DRS)
============================= */
getMaterialDisposedSummary: (payload: {
  project: number;
  vendor?: number;
  cmp?: number;
}) =>
  apiFetch<
    {
      materialName: string;
      unit: string;
      totalDisposed: number;
    }[]
  >(
    "/MaterialdisposedModule/summary",
    {
      method: "POST",
      body: JSON.stringify({
        project: payload.project,
        vendor: payload.vendor ?? 0,
        cmp: payload.cmp ?? 0
      }),
    }
  ),
/* =============================
   SITE CASH PAYMENTS (LedgerNetBalance)
============================= */
/*getSiteCashPayments: (payload: {
  project: number;
  qDate: string;
  endDate: string;
  ledger: number;
}) =>
  apiFetch<{
    success: boolean;
    totalDebit: number;
    totalCredit: number;
    data: any[];
  }>(
    "/LedgerReportEndpoint/site-cash-payments",
    {
      method: "POST",
      body: JSON.stringify(payload),
    }
  ),*/

  /* =============================
   SITE CASH PAYMENTS DASHBOARD
============================= */
getSiteCashPaymentsDashboard: (payload: {
  project: number;
  ledger: number;
}) =>
  apiFetch<{
    success: boolean;
    opening: number;
    totalDebit: number;
    totalCredit: number;
    closing: number;
    data: any[];
  }>(
    "/LedgerReportEndpoint/site-cash-payments",
    {
      method: "POST",
      body: JSON.stringify(payload),
    }
  ),
/* =============================
   EQUIPMENT STATEMENT (Single Date)
============================= */
/*getEquipmentStatement: (payload: {
  project: number;
  date: string;
  vendor?: number;
  cmp?: number;
}) =>
  apiFetch<any[]>(
    "/EquipmentStatementModule/Get",
    {
      method: "POST",
      body: JSON.stringify({
        project: payload.project,
        qDate: payload.date,
        endDate: payload.date,   // single date used for both
        vendor: payload.vendor ?? -1,
        cmp: payload.cmp ?? 0
      }),
    }
  ),*/
  /* =============================
   EQUIPMENT STATEMENT DASHBOARD
============================= */
getEquipmentStatementDashboard: (payload: {
  project: number;
  vendor?: number;
  cmp?: number;
}) =>
  apiFetch<any[]>(
    "/EquipmentStatementModule/Dashboard",
    {
      method: "POST",
      body: JSON.stringify({
        project: payload.project,
        vendor: payload.vendor ?? -1,
        cmp: payload.cmp ?? 0
      }),
    }
  ),

  /* =============================
   WORKS PROGRESS REPORT (Single Date)
============================= */
/*getWorksQtyReport: (
  wbs: number,
  date: string,
  lvl: number = 10,
  fv1: number = 0,
  overrideFlag: number = 1
) =>
  apiFetch<any[]>(
    `/WorksQtyReport?WBS=${wbs}&QDate=${date}&EndDate=${date}&lvl=${lvl}&fv1=${fv1}&overrideFlag=${overrideFlag}`
  ),*/
/* =============================
   WORKS PROGRESS REPORT
============================= */
getWorksQtyReport: (
  wbs: number,
  qDate?: string | null,
  endDate?: string | null,
  lvl: number = 0,
  fv1: number = 0,
  overrideFlag: number = 1
) => {

  let url = `/WorksQtyReport?WBS=${wbs}&lvl=${lvl}&fv1=${fv1}&overrideFlag=${overrideFlag}`;

  if (qDate) {
    url += `&QDate=${qDate}`;
  }

  if (endDate) {
    url += `&EndDate=${endDate}`;
  }

  //return apiFetch<any[]>(url);
  return apiFetch<{
  data: any[];
  usedQDate: string;
  usedEndDate: string;
}>(url);
},

/* =============================
   GROUP PROGRESS REPORT (Single Date)
============================= */
getGroupProgressReport: (
  projectId: number,
  date: string
) =>
  apiFetch<any[]>(
    "/GroupReportModule/progress",
    {
      method: "POST",
      body: JSON.stringify({
        wbs: -1 * projectId,   // IMPORTANT
        qDate: date,
        endDate: date,
        lvl: 0,
        fv1: 1,
        override: 0
      }),
    }
  ),
  /* =============================
   GROUP PROGRESS RANGE REPORT
============================= */
/*getGroupProgressRangeReport: (payload: {
  wbs: number;
 // endDate: string;
  endDate?: string | null;   // ✅ changed
  qDate?: string | null;
  lvl?: number;
}) =>
  apiFetch<any[]>(
    "/GroupProgressReport/get",
    {
      method: "POST",
      body: JSON.stringify({
        wbs: payload.wbs,
        qDate: payload.qDate ?? null,
       // endDate: payload.endDate,
       endDate: payload.endDate ?? null,  // ✅ changed
        lvl: payload.lvl ?? 0
      }),
    }
  ),*/

  getProjectStartDate: (projectId: number) =>
  apiFetch<{
    startDate: string;
  }>(
    `/ProjectInfo/start-date/${projectId}`
  ),

  getGroupProgressRangeReport: (payload: {
  wbs: number;
  endDate?: string | null;
  qDate?: string | null;
  lvl?: number;
}) =>
 /* apiFetch<{
    Data: any[];
    UsedQDate: string;
    UsedEndDate: string;
  }>*/
 apiFetch<{
  data: any[];
  usedQDate: string;
  usedEndDate: string;
}>
    (
    "/GroupProgressReport/get",
    {
      method: "POST",
      body: JSON.stringify({
        wbs: payload.wbs,
        qDate: payload.qDate ?? null,
        endDate: payload.endDate ?? null,
        lvl: payload.lvl ?? 0
      }),
    }
  ),


  getMarkwiseProgressRange: (payload: {
  wbs: number;
  qDate?: string | null;
  endDate?: string | null;
  lvl?: number;
}) =>
  apiFetch<{
    data: any[];
    usedQDate: string;
    usedEndDate: string;
  }>(
    "/MarkwiseProgressRange/report",
    {
      method: "POST",
      body: JSON.stringify({
        wbs: payload.wbs,
        qDate: payload.qDate ?? null,
        endDate: payload.endDate ?? null,
        lvl: payload.lvl ?? 0
      }),
    }
  ),

  getMaterialStatementVendorWise: (payload: {
    project: number
    qDate: string
    endDate: string
    vendor?: number
    component?: number
  }) =>
    apiFetch<any[]>(
      "/MaterialStatementVendorWise",
      {
        method: "POST",
        body: JSON.stringify({
          project: payload.project,
          qDate: payload.qDate,
          endDate: payload.endDate,
          vendor: payload.vendor ?? -1,
          component: payload.component ?? 0
        })
      }
    ),

getManPowerStatementVendorWise: (payload: {
  project: number
  qDate: string
  endDate: string
  vendor?: number
  component?: number
}) =>
  apiFetch<any[]>(
    "/ManPowerStatementVendorWise/report",
    {
      method: "POST",
      body: JSON.stringify({
        project: payload.project,
        startDate: payload.qDate,
        endDate: payload.endDate,
        vendor: payload.vendor ?? -1,
        component: payload.component ?? 0
      })
    }
  ),

  getManPowerStatementResourceWise: (payload: {
  project: number
  qDate: string
  endDate: string
  vendor?: number
  cmp?: number
}) =>
  apiFetch<any[]>(
    "/ManPowerStatementResourceWise/get-report",
    {
      method: "POST",
      body: JSON.stringify({
        project: payload.project,
        qDate: payload.qDate,
        endDate: payload.endDate,
        vendor: payload.vendor ?? -1,
        cmp: payload.cmp ?? 0
      })
    }
  ),

  /* =============================
   EQUIPMENT STATEMENT RESOURCE WISE
============================= */
getEquipmentStatementResourceWise: (payload: {
  project: number
  startDate: string
  endDate: string
  vendor?: number
  cmp?: number
}) =>
  apiFetch<any[]>(
    "/EquipmentStatementResourceWiseModule/get-report",
    {
      method: "POST",
      body: JSON.stringify({
        startDate: payload.startDate,
        endDate: payload.endDate,
        projectId: payload.project,
        vendor: payload.vendor ?? -1,
        component: payload.cmp ?? 0
      })
    }
  ),
getDrawingsReport: (payload: {
  projectId: number
  startDate: string
  endDate: string
}) =>
  apiFetch<any[]>(
    "/DrawingsReport/get-drawings-report",
    {
      method: "POST",
      body: JSON.stringify({
        projectId: payload.projectId,
        startDate: payload.startDate,
        endDate: payload.endDate
      })
    }
  ),

  getEquipmentStatementVendorWise: (payload: {
  project: number
  qDate: string
  endDate: string
  vendor?: number
  cmp?: number
}) =>
  apiFetch<any[]>(
    "/EquipmentStatementVendorWiseReport/GetReport",
    {
      method: "POST",
      body: JSON.stringify({
        project: payload.project,
        qDate: payload.qDate,
        endDate: payload.endDate,
        vendor: payload.vendor ?? -1,
        cmp: payload.cmp ?? 0
      })
    }
  ),

  getWeatherKeywordReport: (payload:{
  projectId:number
  startDate:string
  endDate:string
  keyword:string
}) =>
  apiFetch<any[]>(
    "/DRSWeatherKeywordReport/report",
    {
      method:"POST",
      body:JSON.stringify({
        projectId: payload.projectId,
        startDate: payload.startDate,
        endDate: payload.endDate,
        keyword: payload.keyword
      })
    }
  ),
  

};
// =============================
// TASK REPORT (ADD THIS)
// =============================
/*export const TaskReportAPI = {
  getTaskReport: (projectId: number, date: string) =>
    apiFetch<Record<string, any[]>>(
      `/taskreport?projectId=${projectId}&date=${date}`
    ),
}*/
export const TaskReportAPI = {
  getTaskReport: (projectId: number, date: string) =>
    apiFetch<Record<string, any[]>>(
      `/taskreport-summary?projectId=${projectId}&date=${date}`
    ),
}



export default apiFetch;
